import { compose } from 'redux';
import { ConfigProps, reduxForm } from 'redux-form';
import React from 'react';

import ReturnPolicyForm from '../components/ReturnPolicyForm';
import FormName from '../constants/FormName';
import { submitReturnPolicyForm } from '../actions';
import { ReturnPolicyFormProps, ReturnPolicyFormValues } from '../types';
import { ThunkDispatcher } from '../../../stores/types';

interface MultipleFilterError {
  field: string;
  operator: string;
  values: string;
}

function handleSubmit(values: ReturnPolicyFormValues, dispatch: ThunkDispatcher) {
  return dispatch(submitReturnPolicyForm(values));
}

function handleValidation(values: ReturnPolicyFormValues) {
  // Need to use any type here, there is an issue with the typings
  // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/23922
  // Unlikely to get fixed since redux-form is deprecated (open issue from 2018)
  const errors: any = {};

  if (!values.organizationId) {
    errors.organizationId = 'An organization identifier is required';
  }

  if (!values.filters || !values.filters.length) {
    errors.filters = {
      _error: 'At least one return policy must be entered',
    };
  } else {
    const filterArrayErrors: Partial<MultipleFilterError>[] = [];

    values.filters.forEach((filter, index) => {
      const filterErrors: Partial<MultipleFilterError> = {};

      if (!filter.field) {
        filterErrors.field = 'This field is required';
        filterArrayErrors[index] = filterErrors;
      }

      if (!filter.operator) {
        filterErrors.operator = 'This field is required';
        filterArrayErrors[index] = filterErrors;
      }

      if (!filter.values) {
        filterErrors.values = 'This field is required';
        filterArrayErrors[index] = filterErrors;
      } else if (!Array.isArray(filter.values)) {
        filterErrors.values = 'This field must be an array. Contact the engineer that implemented this form.';
        filterArrayErrors[index] = filterErrors;
      } else if (!filter.values.length) {
        filterErrors.values = 'This field is required';
        filterArrayErrors[index] = filterErrors;
      }
    });

    if (filterArrayErrors.length) {
      errors.filters = filterArrayErrors;
    }
  }

  return errors;
}

export default compose<React.FC<
ReturnPolicyFormProps & ConfigProps<ReturnPolicyFormValues, ReturnPolicyFormProps>>>(
  reduxForm({
    form: FormName.ReturnPolicyForm,
    onSubmit: handleSubmit,
    validate: handleValidation,
  }),
)(ReturnPolicyForm);
